import React from 'react'
import { Widget } from 'features/types'
import {
  TopicNotSelectedGuard,
  WidgetLoadingGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard
} from 'components/widget/share/guards'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import RunSearchEffect from '../share/RunSearchEffect'
import SummaryMetricsCompactNoDataGuard from '../share/guards/SummaryMetricsCompactNoDataGuard'
import SummaryMetricsCompactWidget from '../share/SummaryMetricsCompact'

const AudienceSummaryMetricsCompactWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <TopicNotSelectedGuard widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId} isAudienceQuery>
        <WidgetLoadingGuard widgetId={widgetId}>
          <SummaryMetricsCompactNoDataGuard widgetId={widgetId}>
            <TopicInaccessibleGuard widgetId={widgetId}>
              <TopicIndexNotReadyGuard widgetId={widgetId}>
                <SummaryMetricsCompactWidget widgetId={widgetId} />
              </TopicIndexNotReadyGuard>
            </TopicInaccessibleGuard>
          </SummaryMetricsCompactNoDataGuard>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </TopicNotSelectedGuard>
  </UnexpectedErrorBoundary>
)

export default AudienceSummaryMetricsCompactWidget
